import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { initI18n } from './i18n'

dayjs.extend(utc)
dayjs.extend(timezone)
initI18n()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
